var __WEBPACK_NAMESPACE_OBJECT__ = html2pdf;